
import React from 'react';
import appTypes from '../../../../constants/types';
import SectionCard from '../../../../components/section-card';
import { TextDataField } from '../../../../components/data-fields';

export const GoogleRemoveMemberFromGroupDetails = ({ ticket }) => (
  <SectionCard title="Group Details">
      <TextDataField
      name="Member Email"
      value={ticket && ticket.ticket_data.member_email} />
    <TextDataField
      name="Group Email"
      value={ticket && ticket.ticket_data.group_email} />
  </SectionCard>
);

GoogleRemoveMemberFromGroupDetails.propTypes = {
  ticket: appTypes.ticket.props,
};
GoogleRemoveMemberFromGroupDetails.defaultProps = {
  ticket: appTypes.ticket.default,
};
